module.exports = __webpack_public_path__ + "static/img/8.f7c2e72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/8.jpg
// module id = 426
// module chunks = 1